import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { AiChatWindowMessagesComponent } from '@panaya/ai-chat/ui';
import {
    AiChatThinkingService,
    AiChatConversationService,
    AiChatSuggestionsFetcherService,
    AiChatSuggestionsProviderService,
    AiChatThreadService
} from '../conversation-tools';
import { AsyncPipe } from '@angular/common';

@Component({
    standalone: true,
    selector: 'p-ai-chat-window-content',
    imports: [AsyncPipe, AiChatWindowMessagesComponent],
    templateUrl: './ai-chat-window-content.component.html',
    styleUrls: ['./ai-chat-window-content.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class AiChatWindowContentComponent {
    protected readonly conversation = inject(AiChatConversationService);
    protected readonly threadService = inject(AiChatThreadService);
    protected readonly suggestionsProvider = inject(AiChatSuggestionsProviderService);
    protected readonly suggestionsFetchService = inject(AiChatSuggestionsFetcherService);
    protected readonly thinking = inject(AiChatThinkingService);
}
